import { createContext } from 'react';

export const InitialState = {
  startSendDocumentsJob: () => {},
  loading: false,
  error: null,
  scheduled: false
};

export const SendDocumentsJobContext = createContext(InitialState);

SendDocumentsJobContext.displayName = 'SendDocumentsJobContext';
